import { useState, useEffect } from "react";
import UserIcon from "../../src/assets/user-icon.jpg";
import { toast } from "react-toastify";

export const DEGREE_OPTIONS = [
  { value: "Bachelor of Arts (B.A.)", label: "Bachelor of Arts (B.A.)" },
  {
    value: "Bachelor of Science (B.Sc.)",
    label: "Bachelor of Science (B.Sc.)",
  },
  {
    value: "Bachelor of Commerce (B.Com)",
    label: "Bachelor of Commerce (B.Com)",
  },
  {
    value: "Bachelor of Business Administration (BBA)",
    label: "Bachelor of Business Administration (BBA)",
  },
  {
    value: "Bachelor of Computer Applications (BCA)",
    label: "Bachelor of Computer Applications (BCA)",
  },
  {
    value: "Bachelor of Technology (B.Tech)",
    label: "Bachelor of Technology (B.Tech)",
  },
  {
    value: "Bachelor of Engineering (B.E.)",
    label: "Bachelor of Engineering (B.E.)",
  },
  { value: "Bachelor of Laws (LL.B.)", label: "Bachelor of Laws (LL.B.)" },
  {
    value: "Bachelor of Medicine, Bachelor of Surgery (MBBS)",
    label: "Bachelor of Medicine, Bachelor of Surgery (MBBS)",
  },
  {
    value: "Bachelor of Pharmacy (B.Pharm)",
    label: "Bachelor of Pharmacy (B.Pharm)",
  },
  {
    value: "Bachelor of Architecture (B.Arch)",
    label: "Bachelor of Architecture (B.Arch)",
  },
  {
    value: "Bachelor of Fine Arts (BFA)",
    label: "Bachelor of Fine Arts (BFA)",
  },
  {
    value: "Bachelor of Dental Surgery (BDS)",
    label: "Bachelor of Dental Surgery (BDS)",
  },
  { value: "Master of Arts (M.A.)", label: "Master of Arts (M.A.)" },
  { value: "Master of Science (M.Sc.)", label: "Master of Science (M.Sc.)" },
  { value: "Master of Commerce (M.Com)", label: "Master of Commerce (M.Com)" },
  {
    value: "Master of Business Administration (MBA)",
    label: "Master of Business Administration (MBA)",
  },
  {
    value: "Master of Computer Applications (MCA)",
    label: "Master of Computer Applications (MCA)",
  },
  {
    value: "Master of Technology (M.Tech)",
    label: "Master of Technology (M.Tech)",
  },
  {
    value: "Master of Engineering (M.E.)",
    label: "Master of Engineering (M.E.)",
  },
  { value: "Master of Laws (LL.M.)", label: "Master of Laws (LL.M.)" },
  {
    value: "Master of Pharmacy (M.Pharm)",
    label: "Master of Pharmacy (M.Pharm)",
  },
  { value: "Master of Fine Arts (MFA)", label: "Master of Fine Arts (MFA)" },
  {
    value: "Master of Philosophy (M.Phil)",
    label: "Master of Philosophy (M.Phil)",
  },
  {
    value: "Doctor of Philosophy (Ph.D.)",
    label: "Doctor of Philosophy (Ph.D.)",
  },
  { value: "Other", label: "Other" },
];

const EditYourProfile = ({ onClose, mode = "fullProfile" }) => {
  const [showPhotoPopup, setShowPhotoPopup] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [profilePictureUrl, setProfilePictureUrl] = useState(null);
  const [name, setName] = useState("");
  const [bio, setBio] = useState("");
  const [degree, setDegree] = useState("");
  const [institution, setInstitution] = useState("");
  const [primary_affiliation, setPrimaryAffiliation] = useState("");
  const [current_activity, setCurrentActivity] = useState("");
  const [loading, setLoading] = useState(false);
  const [otherDegree, setOtherDegree] = useState("");
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = localStorage.getItem("access_token");

  const handleImageUpload = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      setProfileImage(file);
      setShowPhotoPopup(false);
    }
  };

  const fetchCurrentUser = async () => {
    try {
      const res = await fetch(`${BASE_URL}/user/profile/create-profile/`, {
        headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY, },
      });
      const data = await res.json();
      if (res.ok && data.data) {
        const username = data.data?.name;
        setName(username);
        setDegree(data.data?.degree);
        setInstitution(data.data?.institution);
        setCurrentActivity(data.data?.current_activity);
        setPrimaryAffiliation(data.data?.primary_affiliation);
        setProfilePictureUrl(data.data?.profile_picture || null);
        setBio(data.data?.bio);
        localStorage.setItem("user_id", data.data?.user);
      } else {
        toast.error(data?.message || "Failed to fetch user info.");
      }
    } catch (err) {
      console.error("Error fetching user:", err);
      toast.error("Something went wrong while fetching user.");
    }
  };


  useEffect(() => {
    fetchCurrentUser();
  }, [token]);

  const handleEdit = async () => {
    if (!name?.trim()) {
      toast.error("Name is required");
      return;
    }
    if (!degree) {
      toast.error("Please select a degree");
      return;
    }
    if (degree === "Other" && !otherDegree.trim()) {
      toast.error("Please select a degree");
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    // formData.append("degree", degree);
    formData.append("degree", degree === "Other" ? otherDegree : degree);
    formData.append("primary_affiliation", primary_affiliation);
    formData.append("current_activity", current_activity);
    formData.append("bio", bio);
    formData.append("institution", institution);
    if (profileImage) formData.append("profile_picture", profileImage);
    setLoading(true);
    try {
      const res2 = await fetch(`${BASE_URL}/user/profile/create-profile/`, {
        method: "PATCH",
        headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY, },
        body: formData,
      });
      if (!res2.ok) throw new Error("Failed to update profile");
      toast.success("Profile updated successfully");
      onClose();
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const renderContent = () => {
    if (mode === "aboutMe") {
      return (
       
      <div className="space-y-6">
  {/* Introduction */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">
        Introduction
      </label>
    </div>
    <textarea
      placeholder="Write a short intro to tell people about yourself..."
      className="w-full min-h-[100px] p-4 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 resize-y transition-all"
    />
    <p className="text-xs text-gray-500 mt-2">Briefly describe yourself and your work</p>
  </div>

  {/* Disciplines */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">
        Research Disciplines
      </label>
    </div>
    <input
      type="text"
      placeholder="e.g. Analysis | Applied Mathematics | Machine Learning"
      className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
    />
    <p className="text-xs text-gray-500 mt-2">Separate disciplines with | symbol</p>
  </div>

  {/* Twitter Profile */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">
        Twitter Profile
      </label>
    </div>
    <div className="relative">
      <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.213c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
        </svg>
      </div>
      <input
        type="url"
        placeholder="twitter.com/username or @username"
        className="w-full pl-12 pr-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
    </div>
    <p className="text-xs text-gray-500 mt-2 flex items-center gap-1">
      <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      Only visible to mutual followers
    </p>
  </div>

  {/* Website */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">
        Website
      </label>
    </div>
    <div className="relative">
      <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
        </svg>
      </div>
      <input
        type="url"
        placeholder="https://example.com"
        className="w-full pl-12 pr-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
    </div>
    <p className="text-xs text-gray-500 mt-2 flex items-center gap-1">
      <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      Only visible to mutual followers
    </p>
  </div>
</div>

      );
    } else if (mode === "featuredResearch") {
      return (
        <div className="bg-white rounded-2xl p-6 shadow-lg max-w-xl w-full">
  {/* Header */}
  <div className="flex items-center gap-3 mb-6">
    <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
      <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
      </svg>
    </div>
    <div>
      <h2 className="text-lg font-semibold text-gray-900">Feature Research</h2>
      <p className="text-sm text-gray-500 mt-0.5">Select research to showcase on your profile</p>
    </div>
  </div>

  {/* Search Bar */}
  <div className="mb-6">
    <div className="relative">
      <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
      <input
        type="text"
        placeholder="Search research by title, keywords..."
        className="w-full pl-12 pr-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
    </div>
  </div>

  {/* Filters and Counter */}
  <div className="flex items-center justify-between mb-6 p-3 bg-gray-50 rounded-xl">
    <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
      <div className="relative">
        <input 
          type="checkbox" 
          className="sr-only" 
        />
        <div className="w-5 h-5 border-2 border-gray-300 rounded flex items-center justify-center">
          <svg className="w-3 h-3 text-[#0f6abf] hidden" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
          </svg>
        </div>
      </div>
      <span>Show selected only</span>
    </label>

    <div className="text-right">
      <div className={`text-sm font-medium ${0 >= 1 ? 'text-green-600' : 'text-red-600'}`}>
        {0}/5 selected
      </div>
      {0 < 1 && (
        <div className="text-xs text-red-500 mt-0.5">Select at least 1 research</div>
      )}
    </div>
  </div>

  {/* Research List */}
  <div className="border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center">
    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
      <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    </div>
    <h3 className="text-lg font-medium text-gray-700 mb-2">No research selected</h3>
    <p className="text-sm text-gray-500 mb-4">Search and select research to feature on your profile</p>
    <button className="px-4 py-2 bg-[#e8f0f7] text-[#0f6abf] text-sm font-medium rounded-lg hover:bg-[#d0e0f0] transition-colors">
      Browse Research
    </button>
  </div>

  {/* Selected Count Indicator */}
  <div className="mt-6 pt-6 border-t border-gray-200">
    <div className="flex items-center justify-between">
      <div className="text-sm text-gray-600">
        Featured research will appear on your public profile
      </div>
      <button className="px-4 py-2 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
        Save Selection
      </button>
    </div>
  </div>
</div>
      );
    } else if (mode === "primary_affiliation") {
      return (
        <div className="space-y-6">
  <div className="p-4 bg-gray-50 rounded-xl">
    <p className="text-sm text-gray-600">
      Edit details about your primary affiliation.
    </p>
  </div>

  {/* Institution */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">
        Institution <span className="text-red-500">*</span>
      </label>
    </div>
    <input
      type="text"
      placeholder="University, Company, or Organization"
      className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
    />
  </div>

  {/* Department */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">
        Department
      </label>
    </div>
    <input
      type="text"
      placeholder="e.g. Computer Science, Research & Development"
      className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
    />
  </div>

  {/* Position */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">
        Position <span className="text-red-500">*</span>
      </label>
    </div>
    <input
      type="text"
      placeholder="#Doctor. #Teacher in Mathematics. #Software Engineer"
      className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
    />
  </div>

  {/* Checkbox */}
  <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl">
    <div className="relative">
      <input type="checkbox" id="currently-work" className="sr-only" />
      <div className="w-5 h-5 border-2 border-gray-300 rounded flex items-center justify-center">
        <svg className="w-3 h-3 text-[#0f6abf] hidden" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
        </svg>
      </div>
    </div>
    <label htmlFor="currently-work" className="text-sm text-gray-700 cursor-pointer">
      I currently work here
    </label>
  </div>

  {/* Start Date */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">
        Start Date
      </label>
    </div>
    <div className="grid grid-cols-2 gap-4">
      <select 
        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right 16px center'
        }}
        required
      >
        <option value="">Month *</option>
        {[
          "January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"
        ].map((m) => (
          <option key={m} value={m}>{m}</option>
        ))}
      </select>
      
      <select 
        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right 16px center'
        }}
        required
      >
        <option value="">Year *</option>
        {Array.from({ length: 50 }, (_, i) => {
          const year = new Date().getFullYear() - i;
          return <option key={year} value={year}>{year}</option>;
        })}
      </select>
    </div>
  </div>

  {/* Country & City */}
  <div className="grid grid-cols-2 gap-4">
    <div>
      <div className="flex items-center gap-2 mb-3">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <label className="text-sm font-semibold text-gray-700">
          Country/Region
        </label>
      </div>
      <select 
        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right 16px center'
        }}
      >
        <option>Canada</option>
        <option>United States</option>
        <option>India</option>
        <option>United Kingdom</option>
        <option>Other</option>
      </select>
    </div>
    
    <div>
      <div className="flex items-center gap-2 mb-3">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <label className="text-sm font-semibold text-gray-700">
          City
        </label>
      </div>
      <input
        type="text"
        placeholder="Enter city name"
        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
    </div>
  </div>

  {/* Description */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">
        Description
      </label>
    </div>
    <textarea
      placeholder="Tell others about your role, research focus, and your achievements..."
      className="w-full min-h-[100px] p-4 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 resize-y transition-all"
      maxLength={500}
    />
    <div className="flex justify-between items-center mt-2">
      <p className="text-xs text-gray-500">Describe your responsibilities and achievements</p>
      <div className="text-xs text-gray-500">0/500</div>
    </div>
  </div>
</div>
      );
    } else if (mode === "skills") {
      return (
        <div className="space-y-6">
  <h4 className="text-lg font-semibold text-gray-900">Add your skills</h4>

  {/* Skills Input */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">
        Skills
      </label>
    </div>
    <input
      type="text"
      placeholder="Add skills separated by commas"
      className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
    />
    <p className="text-xs text-gray-500 mt-2">
      e.g. UI Design, ReactJS, Academic Writing
    </p>
  </div>

  {/* Selected Skills */}
  <div className="border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center">
    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
      <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
      </svg>
    </div>
    <h3 className="text-lg font-medium text-gray-700 mb-2">No skills added yet</h3>
    <p className="text-sm text-gray-500">Add skills to showcase your expertise</p>
  </div>
</div>
      );
    }

    return (
    <div className="space-y-5">
  {/* Name */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">
        Name
      </label>
    </div>
    <input
      type="text"
      placeholder="Enter your full name"
      className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      value={name}
      onChange={(e) => setName(e.target.value)}
    />
  </div>

  {/* Degree */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">
        Degree
      </label>
    </div>
    <select
      className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
      style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 16px center'
      }}
      value={degree}
      onChange={(e) => setDegree(e.target.value)}
      required
    >
      <option value="">Select your degree</option>
      {DEGREE_OPTIONS.map((deg) => (
        <option key={deg.value} value={deg.value}>
          {deg.label}
        </option>
      ))}
    </select>
    
    {degree === "Other" && (
      <div className="mt-3">
        <input
          type="text"
          placeholder="Enter your degree name"
          className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
          value={otherDegree}
          onChange={(e) => setOtherDegree(e.target.value)}
          required
        />
      </div>
    )}
  </div>

  {/* Primary Affiliation */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">
        Primary Affiliation
      </label>
    </div>
    <input
      type="text"
      placeholder="University, Company, or Organization"
      className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      value={primary_affiliation}
      onChange={(e) => setPrimaryAffiliation(e.target.value)}
    />
  </div>

  {/* Institution */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">
        Institution <span className="text-red-500">*</span>
      </label>
    </div>
    <input
      type="text"
      placeholder="Enter your institution name"
      className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      value={institution}
      onChange={(e) => setInstitution(e.target.value)}
    />
  </div>

  {/* Bio */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">
        Bio
      </label>
    </div>
    <input
      type="text"
      placeholder="Brief professional biography"
      className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      value={bio}
      onChange={(e) => setBio(e.target.value)}
    />
  </div>

  {/* Current Activity */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">
        Current Activity
      </label>
    </div>
    <textarea
      placeholder="Describe your current work, research, or project..."
      className="w-full min-h-[100px] p-4 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 resize-y transition-all"
      value={current_activity}
      onChange={(e) => setCurrentActivity(e.target.value)}
    />
    <p className="text-xs text-gray-500 mt-2">Describe your current focus or ongoing work</p>
  </div>
</div>

    );
  };

  return (
  <div className="bg-white rounded-2xl p-6 shadow-lg relative">
  {/* Header */}
  <div className="flex items-center justify-between mb-6">
    <div className="flex items-center gap-3">
      <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
        <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
        </svg>
      </div>
      <div>
        <h3 className="text-lg font-semibold text-gray-900">Edit Your Profile</h3>
        <p className="text-sm text-gray-500 mt-0.5">Update your personal information</p>
      </div>
    </div>
    <button
      className="w-10 h-10 flex items-center justify-center rounded-xl hover:bg-gray-100 transition-colors"
      onClick={onClose}
    >
      <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>

  {/* Profile Picture Section */}
  {mode === "fullProfile" && (
    <div className="flex flex-col items-center mb-8">
      <div className="relative">
        <img
          src={
            profileImage
              ? URL.createObjectURL(profileImage)
              : profilePictureUrl || UserIcon
          }
          alt="Profile"
          className="w-28 h-28 rounded-2xl object-cover border-4 border-white shadow-lg"
        />
        <button
          className="absolute -bottom-2 -right-2 w-10 h-10 bg-[#0f6abf] rounded-full flex items-center justify-center text-white hover:bg-[#0a5ca8] transition-colors shadow-md"
          onClick={() => setShowPhotoPopup(true)}
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
          </svg>
        </button>
      </div>
      <p className="text-sm text-gray-500 mt-4">Click the + button to update photo</p>
    </div>
  )}

  {/* Photo Popup Modal */}
  {showPhotoPopup && (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl w-full max-w-md shadow-xl">
        <div className="p-6 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <div>
              <h4 className="text-lg font-semibold text-gray-900">Update Profile Photo</h4>
              <p className="text-sm text-gray-500 mt-0.5">Choose a new photo for your profile</p>
            </div>
          </div>
        </div>
        
        <div className="p-6">
          <div className="flex justify-center">
            <label className="flex flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 rounded-2xl cursor-pointer hover:border-[#0f6abf] hover:bg-[#e8f0f7]/10 transition-colors w-full">
              <div className="w-16 h-16 bg-[#e8f0f7] rounded-full flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <span className="font-medium text-gray-900">Choose from gallery</span>
              <span className="text-sm text-gray-500 mt-1">JPG, PNG up to 5MB</span>
              <input
                type="file"
                accept="image/*"
                className="hidden"
                onChange={handleImageUpload}
              />
            </label>
          </div>
        </div>
        
        <div className="px-6 py-4 bg-gray-50/50 border-t border-gray-100">
          <button
            className="w-full py-2.5 text-gray-700 font-medium rounded-xl hover:bg-gray-100 transition-colors"
            onClick={() => setShowPhotoPopup(false)}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  )}

  {/* Edit Profile Inputs */}
  <div className="mb-8">
    {renderContent()}
  </div>

  {/* Save & Cancel Buttons */}
  <div className="flex items-center justify-end gap-3 pt-6 border-t border-gray-100">
    <button
      className="px-5 py-2.5 text-gray-700 font-medium rounded-xl hover:bg-gray-100 transition-colors"
      onClick={onClose}
    >
      Cancel
    </button>
    <button
      className="px-5 py-2.5 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center gap-2 disabled:opacity-50"
      onClick={handleEdit}
      disabled={loading}
    >
      {loading ? (
        <>
          <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          Saving...
        </>
      ) : (
        <>
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
          Save Changes
        </>
      )}
    </button>
  </div>
</div>

  );
};

export default EditYourProfile;
